import { data } from '../../svg/Restore/data';
import { makeIcon } from '../makeIcon';

export const Restore = makeIcon(data, 'history', 'Restore');

export default Restore;
